const apiHost = process.env.VUE_APP_API_HOST;

export const fetchCountries = async () => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const url = `${apiHost}/v1/rates_countries`;

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch rates: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return (data as { countries: string[] }).countries;
};
